export default {
  nextJob: 'Nasledujúca zákazka',
  plannedJobMetricsUnavailable: 'Metriky budú dostupné po spustení tejto zákazky.',
  previousJob: 'Predchádzajúca zákazka',
  detailsTabs: {
    consumption: 'Spotreba',
    events: 'Udalosti',
    images: 'Obrázky',
  },
};
